<div class="invoice-content py-2 mt-2">
  <div class="comments-details-label">
    <mat-card class="account-details-card text-white">
      <ul class="list-inline d-inline-flex">
        <li class="list-inline-item my-2 my-lg-0 align-self-center d-inline-block d-xl-none">
          <button mat-mini-fab aria-label="toggle show hide" color="primary" (click)="showCard = !showCard">
            <mat-icon *ngIf="!showCard">arrow_back_ios</mat-icon>
            <mat-icon *ngIf="showCard">arrow_forward_ios</mat-icon>
          </button>
        </li>
        <li class="list-inline-item my-2 my-lg-0">
          <ul class="list-unstyled" *ngIf="showCard">
          <li>
            <h4>
              <span class="translate"> {{'pages.newRetailer.storeName' | translate}} </span>:
              {{ storeName }}
            </h4>
          </li>
          <li>
            <h4>
              <span class="translate"> {{'pages.newRetailer.retailerName' | translate}} </span>:
              {{ retailerName }}
            </h4>
          </li>
          <li>
            <h4>
              <span class="translate"> {{'pages.newRetailer.accountNumber' | translate}} </span>:
              {{ accountNumber }}
            </h4>
          </li>
        </ul>
      </li>
    </ul>
    </mat-card>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="grid-container search-holder">
        <ul class="list-inline mb-3 mb-sm-5">
          <li class="list-inline-item my-2 my-lg-0">
            <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
          </li>
          <li class="list-inline-item my-2 my-lg-0">
            <div class="calendar-btn">
              <input matInput [matDatepicker]="dpFrom" disabled [min]="minFromDate" placeholder="MM/DD/YYYY"
                [max]="maxDate" (dateChange)="changeFromDate($event)" />
              <mat-datepicker-toggle matSuffix [for]="dpFrom"></mat-datepicker-toggle>
              <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
            </div>
          </li>
          <li class="list-inline-item my-2 my-lg-0">
            <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
          </li>
          <li class="list-inline-item my-2 my-lg-0">
            <div class="calendar-btn">
              <input matInput [matDatepicker]="dpTo" disabled [min]="minToDate" placeholder="MM/DD/YYYY" [max]="maxDate"
                (dateChange)="changeToDate($event)" />
              <mat-datepicker-toggle matSuffix [for]="dpTo"></mat-datepicker-toggle>
              <mat-datepicker #dpTo disabled="false"></mat-datepicker>
            </div>
          </li>
          <li class="list-inline-item my-2 my-lg-0 ">
            <div class="search-holder">
              <input type="text" placeholder="{{ 'pages.newRetailer.search' | translate }}" matInput class="
                    rounded-pill
                    px-3
                    py-2
                    mb-0
                    border-0
                    bg-light
                    w-100
                    me-0
                    input-search
                    ms-3
                  " (keyup)="quickSearch()" [(ngModel)]="searchValue" />
            </div>
          </li>


          <li class="list-inline-item my-2 my-lg-0 float-lg-end ">
            <button mat-stroked-button color="primary" class="" (click)="exportData()">
              <span translate class="translate">pages.newRetailer.download</span>
              <i class="mi mi-save-alt"></i>
            </button>
          </li>
          <li class="list-inline-item my-2 my-lg-0 float-lg-end ">
            <button [ngStyle]="{'display': userRole === 'Super Admin' ?'block':'none'}" mat-stroked-button
              [disabled]="!isLogSelected" class="bg-theme" (click)="deleteData()" routerLinkActive="router-link-active">
              <span translate class="translate">pages.newRetailer.delete</span>
              <mat-icon>delete_outline</mat-icon>
            </button>
          </li>
          <li class="list-inline-item my-2 my-lg-0 float-lg-end ">
            <button mat-stroked-button [disabled]="!isLogSelected" class="bg-theme" (click)="editData()"
              routerLinkActive="router-link-active">
              <span translate class="translate">pages.newRetailer.edit</span>
              <i class="mi mi-drive-file-rename-outline"></i>
            </button>
          </li>
          <li class="list-inline-item my-2 my-lg-0 float-lg-end  me-2">
            <button
              [ngStyle]="{'display': userRole == 'Sales Rep' || userRole == 'Super Admin' || userRole == 'Sub Admin' || userRole == 'Customer Service' ? 'block':'none'}"
              mat-stroked-button color="primary" class="" (click)="createData()">
              <span translate class="translate">pages.newRetailer.add</span>
              <mat-icon class="ms-2">add_box</mat-icon>
            </button>
            
          </li>
        </ul>
        <div class="mt-2">
          <ag-grid-angular
            #agGrid
            style="width: 100%; height: 60vh"
            id="myGrid"
            class="ag-theme-material"
            [rowHeight]="40"
            [rowSelection]="'single'"
            [rowData]="rowData" [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [tooltipShowDelay]="tooltipShowDelay"
            [frameworkComponents]="frameworkComponents"
            (gridReady)="onGridReady($event)"
            (selectionChanged)="onSelectionChanged($event)"
          ></ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>